/** Props passed by @xyflow/svelte into custom nodes that must not be forwarded to DOM elements. */
const XYFLOW_SHELL_PROP_KEYS = new Set([
	'draggable',
	'dragHandle',
	'selectable',
	'deletable',
	'connectable',
	'isConnectable',
	'dragging',
	'zIndex',
	'parentId',
	'type',
	'sourcePosition',
	'targetPosition',
	'width',
	'height',
	'positionAbsoluteX',
	'positionAbsoluteY',
]);

/** For spreading onto a real DOM node inside a custom node component. */
export function stripXyflowShellProps(rest: Record<string, unknown>): Record<string, unknown> {
	const out: Record<string, unknown> = {};
	for (const [k, v] of Object.entries(rest)) {
		if (!XYFLOW_SHELL_PROP_KEYS.has(k)) out[k] = v;
	}
	return out;
}
